export async function getProductName(productKey, locale) {
  const json = await (await fetch(
    `https://merchandising-site-experience.prod.merch.vpsvc.com/api/v1/tenant/vistaprint/productKey/${productKey}/merchandisedProperty/productName?requestor=Albelli&cultures=${locale}&lower=true`,
  )).json();

  return json[locale].productName;
}

export async function getCoreProductId(mpvId, locale) {
  const json = await (await fetch(
    `https://merchandising-site-experience.prod.merch.vpsvc.com/api/v1/tenant/vistaprint/mpvs/${mpvId}?requestor=Albelli&cultures=${locale}`,
  )).json();

  return json[locale];
}

export async function getMpvId(productKey, locale) {
  const json = await (await fetch(
    `https://merchandising-site-experience.prod.merch.vpsvc.com/api/v1/tenant/vistaprint/productKey/${productKey}/mpvs?requestor=Albelli&cultures=${locale}`,
  )).json();

  return json[locale];
}
